<div class="gnv-dialog-content">
    <lib-table 
        [dataSummary]="tableSummary"
        [tableColumns]="tableColumns"
        [pagination]="undefined"
        [displayFilterButtons]="false"
        [displayRefreshButtons]="false"
        [searchPlaceholder]="'search.search' | translate"
        [withGroupRows]="true"
        [displayGroupModeButton]="(toggleFeatureSelect$ | async)?.displayNonImplementedMenus || false"
        [withCustomFilter]="false"
        groupRowsBy="parent"
        dataKey="parent"
        [groupChecked]="groupChecked"
        (groupChange)="onGroupParentChange($event)"
        (groupItemChange)="onGroupItemChange($event)"
    >
    </lib-table>
</div>

<div class="commands-container">
    <lib-button 
        (gnvOnClick)="close()" 
        [label]="'action.close' | translate" 
    >
    </lib-button>
</div>
